export default String.raw`
.empty-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 24px;
    margin-top: 64px;
    margin-bottom: 16px;

    &__heading {
        display: flex;
        align-items: center;

        svg {
            width: 52px;
            height: 52px;
            margin-right: 24px;
        }
    }

    &__button {
        div {
            display: flex;
            align-items: center;

            svg {
                width: 24px;
                height: 24px;
                margin-left: 8px;
                fill: $secondaryBtnBgColor;
            }
    
            span {
                color: $lightestColorFont;
                @include button;
            }
        }
    }
}
`